<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section">
        <attendence-page />
      </div>
    </div>
  </div>
</template>

<script>
import AttendencePage from '../Components/AttendencePage.vue';

export default {
  name: 'CheckIn',
  components: {
    'attendence-page': AttendencePage,
  },
};
</script>

<style scoped></style>
